export default class ValidationException {
  public constructor(public messages: { [key: string]: string }) {}
}
